import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"border-bottom":"2px solid rgb(21, 130, 156)"},
  class: "mb-6"
}
const _hoisted_2 = { class: "fw-bold mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "fw-bold mb-2"
}
const _hoisted_4 = { class: "d-flex h-100 align-center" }
const _hoisted_5 = { class: "d-flex h-100 align-center" }
const _hoisted_6 = { class: "d-flex h-100 align-center" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  id: "eye-icon-wrapper",
  class: "d-flex"
}

import InfoModalBtnArea from '@/components/AccountParts/InfoModalBtnArea.vue';
import { ref, computed, watch } from 'vue'
import InfoModal from "@/components/Common/InfoModal.vue"
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DriverModeInfoModal',
  props: {
    modelValue: { type: Boolean },
    accountId: {},
    email: {},
    password: {},
    name: {},
    isLoading: { type: Boolean },
    isDriverMode: { type: Boolean },
    roleAssignAuthority: { type: Boolean },
    update: { type: Function }
  },
  emits: ['update:modelValue', 'exec'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props
const passwordMask = ref(true as boolean)
const isCopied = ref(false as boolean)
const passwordMessage = i18n.global.t('pages.accounts.messages.passwordMessage')

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  }
})

const displayPassword = computed(() => {
  if (!props.password) return passwordMessage
  if (passwordMask.value) {
    let password = "*"
    for (let i = 1; i < props.password.length; i++) {
      password = `${password}*`
    }
    return password
  }
  return props.password
})

function isMaskPassword(bool: boolean) {
  passwordMask.value = bool
}

const copyedValue = computed(() => {
  const password = props.password ?? passwordMessage
  return `${i18n.global.t('pages.accounts.accountName')}: ${props.name[0]}${props.name[1]}\n
    ${i18n.global.t('pages.accounts.form.emailAddress')}: ${props.email}\n
    ${i18n.global.t('pages.accounts.form.password')}: ${password}`
})

function changeModalStatus(bool: boolean) {
  modelValue.value = bool
}

watch(() => modelValue.value, (status) => {
  if (!status) {
    isCopied.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(InfoModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue).value = $event)),
    modalWidth: "30%"
  }, {
    text: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.accounts.DriverModelInfoModal.infoMessagesRow1')), 1),
          (!props.accountId)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.accounts.DriverModelInfoModal.infoMessagesRow2')), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              class: "pb-1 text-body-medium",
              cols: "4"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "material-symbols-outlined fs-10 mr-1" }, "person", -1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t('pages.accounts.accountName')) + ":", 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              class: "pb-1 text-body-medium",
              cols: "8",
              style: {"position":"relative"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(props.name[0]) + _toDisplayString(props.name[1]), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              class: "pb-1 text-body-medium",
              cols: "4"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "material-symbols-outlined fs-10 mr-1" }, "mail", -1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t('pages.accounts.form.emailAddress')) + ":", 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              class: "pb-1 text-body-medium",
              cols: "8",
              style: {"position":"relative"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(props.email), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              class: "text-body-medium",
              cols: "4"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "material-symbols-outlined fs-10 mr-1" }, "key_vertical", -1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t('pages.accounts.form.password')) + ":", 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              class: "text-body-medium",
              cols: "8",
              style: {"position":"relative"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(displayPassword.value), 1),
                  (props.password)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives((_openBlock(), _createElementBlock("svg", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (isMaskPassword(true))),
                            viewBox: "0 0 576 512"
                          }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("path", { d: "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" }, null, -1)
                          ]))], 512)), [
                            [_vShow, !passwordMask.value]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("svg", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (isMaskPassword(false))),
                            viewBox: "0 0 640 512"
                          }, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zm223.1 298L373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5z" }, null, -1)
                          ]))], 512)), [
                            [_vShow, passwordMask.value]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(InfoModalBtnArea, {
        modelValue: isCopied.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isCopied).value = $event)),
        copyText: copyedValue.value,
        accountId: props.accountId,
        isLoading: props.isLoading,
        isDriverMode: props.isDriverMode,
        roleAssignAuthority: props.roleAssignAuthority,
        update: props.update,
        changeModalStatus: changeModalStatus
      }, null, 8, ["modelValue", "copyText", "accountId", "isLoading", "isDriverMode", "roleAssignAuthority", "update"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})